import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { selectAllResultUrl, selectIsRenderAllResult } from "../../../../store/slices/search/selectors";
import { ActionSearch } from "../../../../store/slices/search/actions";
import { selectHeaderTheme } from "../../../../store/slices/layout/selectors";
import { FooterButton } from "./FooterButton";
import { ButtonHeaderSearch } from "./ButtonHeaderSearch";
var mapStateToProps = function mapStateToProps(state) {
  return {
    href: selectAllResultUrl(state),
    shouldRender: selectIsRenderAllResult(state)
  };
};
export var FooterButtonRC = compose(connect(mapStateToProps), withRenderFlag)(FooterButton);
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClick: function onClick() {
      return dispatch(ActionSearch.toggleOpenSidebar(true));
    }
  };
};
var mapStateToPropsSearchButton = function mapStateToPropsSearchButton(state) {
  return {
    headerTheme: selectHeaderTheme(state)
  };
};
export var ButtonHeaderSearchRC = connect(mapStateToPropsSearchButton, mapDispatchToProps)(ButtonHeaderSearch);